import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const MultiSelectSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" fill="white" />
        <rect x="9" y="9" width="12" height="1" fill="#BCBEC2" />
        <rect x="9" y="11" width="12" height="1" fill="#BCBEC2" />
        <rect x="9" y="13" width="12" height="1" fill="#BCBEC2" />
        <rect x="9" y="15" width="12" height="1" fill="#BCBEC2" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.66271 13.334L4.59814 15.6683C4.50284 15.7629 4.38425 15.8252 4.25688 15.8477C4.12951 15.8702 3.99888 15.8518 3.88096 15.7948C3.76304 15.7379 3.66294 15.6448 3.5929 15.527C3.52286 15.4092 3.48591 15.2717 3.48658 15.1314V10.293C3.4866 10.1533 3.5239 10.0166 3.59397 9.89954C3.66403 9.78244 3.76385 9.68995 3.8813 9.6333C3.99876 9.57665 4.12881 9.55828 4.25569 9.5804C4.38256 9.60252 4.50081 9.66419 4.59608 9.75793L6.66271 12.0923C6.74223 12.171 6.80575 12.2668 6.84922 12.3737C6.89269 12.4806 6.91514 12.5962 6.91514 12.7131C6.91514 12.83 6.89269 12.9456 6.84922 13.0525C6.80575 13.1594 6.74223 13.2553 6.66271 13.334Z"
          fill="#878A92"
        />
        <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" stroke="#D5D7DD" />
      </svg>
    </span>
  );
};

export default MultiSelectSVG;
